export const filterQuestions = (randomQuestions, type, subject, topic, year, quizNum, quesNum, snum) => {

  if (subject === "atoz" && topic !== "atoz") {
    return randomQuestions.filter(question =>
      // question.type === type  &&
      question.topic === topic &&
      question.quiz === quizNum
    ).slice(0, quesNum);
  }
  else if (topic === "atoz" && subject !== "atoz" && type === "previousyearquestions") {
    return randomQuestions.filter(question =>
      question.type === type &&
      question.subject === subject &&
      question.year === year
    )//.slice(0, quesNum);
  }
  else if (topic === "atoz" && subject !== "atoz") {
    // return randomQuestions.filter(question =>
    //  question.type === "dpp"  &&
    //   question.subject === subject &&
    //    question.topic === "CP01" || question.topic === "CP02" || question.topic === "CP03"
    // ).slice(0, quesNum);

    if (subject === 'physics') {
      // 1. Filter questions by subject and type first
      const pool = randomQuestions.filter(q =>
       ( q.type === "dpp"  ) &&
        q.subject === subject &&
        ["CP01", "CP02", "CP03", "CP04", "CP05", "CP06", "CP07", "CP08", "CP09", "CP10", "CP11", "CP12", "CP13", "CP14", "CP15", "CP16",
          "CP17", "CP18", "CP19", "CP20", "CP21", "CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP28"].includes(q.topic)
      );
      //  Like    const byTopic = {  CP01: pool.filter(q => q.topic === "CP01") };
      const byTopic = {};
      for (let i = 1; i <= 28; i++) {
        const topicKey = `CP${String(i).padStart(2, '0')}`;
        byTopic[topicKey] = pool.filter(q => q.topic === topicKey);
      }

      const finalSelection = [];
      const topics = ["CP14", "CP03", "CP27", "CP08", "CP21", "CP12", "CP05", "CP19", "CP23", "CP01", "CP16", "CP10", "CP25", "CP07",
        "CP18", "CP28", "CP04", "CP22", "CP13", "CP09", "CP26", "CP02", "CP17", "CP11", "CP20", "CP06", "CP15", "CP24"];

      const topLen = topics.length;
      for (let i = snum; finalSelection.length < quesNum; i++) {
        const currentTopic = topics[i % topLen]; // Cycles 0, 1, 2, 0, 1, 2...
        if (byTopic[currentTopic].length > 0) {
          finalSelection.push(byTopic[currentTopic].shift());
        }
        if (topics.every(t => byTopic[t].length === 0)) break;
      }
      return finalSelection;

    } // Chemistry
    else if (subject === 'chemistry') {

      const pool = randomQuestions.filter(q =>
       ( q.type === "dpp"  ) &&
        q.subject === subject &&
        ["CC01", "CC02", "CC03", "CC04", "CC05", "CC06", "CC07", "CC08", "CC09", "CC10", "CC11", "CC12", "CC13",  "CC15", "CC16", "CC17",
          "CC18", "CC21", "CC22", "CC23", "CC24", "CC25", "CC26", "CC27", "CC28"].includes(q.topic)
      );

      const byTopic = {};
      for (let i = 1; i <= 30; i++) {
        const topicKey = `CC${String(i).padStart(2, '0')}`;
        byTopic[topicKey] = pool.filter(q => q.topic === topicKey);
      }

      const finalSelection = [];
      const topics = [ "CC27", "CC05", "CC22", "CC09", "CC18", "CC02", "CC25", "CC11", "CC07", "CC28", "CC13",
        "CC04", "CC21", "CC16", "CC08", "CC26", "CC01", "CC23", "CC10", "CC15", "CC03", "CC12", "CC17", "CC06", "CC24"];

      const topLen = topics.length;
      for (let i = snum; finalSelection.length < quesNum; i++) {
        const currentTopic = topics[i % topLen]; // Cycles 0, 1, 2, 0, 1, 2...
        if (byTopic[currentTopic].length > 0) {
          finalSelection.push(byTopic[currentTopic].shift());
        }
        if (topics.every(t => byTopic[t].length === 0)) break;
      }
      return finalSelection;

    } else { // Biology

      const pool = randomQuestions.filter(q =>
       ( q.type === "dpp" ) &&
        q.subject === subject &&
        ["CB01", "CB02", "CB03", "CB04", "CB05", "CB06", "CB07", "CB08", "CB09", "CB10", "CB13", "CB14", "CB15", "CB17", "CB18", "CB19", "CB20",
          "CB21", "CB22", "CB24", "CB25", "CB26", "CB27", "CB28", "CB29", "CB30", "CB32", "CB33", "CB34", "CB35", "CB36", "CB37"].includes(q.topic));

      const byTopic = {};
      for (let i = 1; i <= 38; i++) {
        const topicKey = `CB${String(i).padStart(2, '0')}`;
        byTopic[topicKey] = pool.filter(q => q.topic === topicKey);
      }

      const finalSelection = [];
      const topics = ["CB14", "CB27", "CB05", "CB22", "CB09", "CB18", "CB02", "CB36", "CB25", "CB19", "CB07",
        "CB33", "CB28", "CB13", "CB04", "CB37", "CB21", "CB08", "CB29", "CB26", "CB01", "CB10",
        "CB34", "CB15", "CB03", "CB20", "CB30", "CB17", "CB06", "CB35", "CB24", "CB32"];

      const topLen = topics.length;
      for (let i = snum; finalSelection.length < quesNum; i++) {
        const currentTopic = topics[i % topLen]; // Cycles 0, 1, 2, 0, 1, 2...
        if (byTopic[currentTopic].length > 0) {
          finalSelection.push(byTopic[currentTopic].shift());
        }
        if (topics.every(t => byTopic[t].length === 0)) break;
      }
      return finalSelection;

    }



  }
  else if (subject === "atoz" && topic === "atoz" && type === "previousyearquestions") {
    // const mathQuestions = randomQuestions.filter(question =>
    //  question.type === type &&
    //   question.subject === "math" 
    // ).slice(0, Math.round(quesNum / 4));

    const physicsQuestions = randomQuestions.filter(question =>
      question.type === type &&
      question.subject === "physics" &&
      question.year === year
    )//.slice(0, Math.round(quesNum / 4));

    const chemistryQuestions = randomQuestions.filter(question =>
      question.type === type &&
      question.subject === "chemistry" &&
      question.year === year
    )//.slice(0, Math.round(quesNum / 4));

    const biologyQuestions = randomQuestions.filter(question =>
      question.type === type &&
      question.subject === "biology" &&
      question.year === year
    )//.slice(0, Math.round(quesNum / 2));

    return [
      // ...mathQuestions,
      ...physicsQuestions,
      ...chemistryQuestions,
      ...biologyQuestions
    ];
  } else if (subject === "atoz" && topic === "atoz") {

    // --- 1. PHYSICS SECTION (25%) ---
    const physTarget = Math.round(quesNum / 4);
    // Using your specific randomized order
    const physTopics = ["CP14", "CP03", "CP27", "CP08", "CP21", "CP12", "CP05", "CP19", "CP23", "CP01", "CP16", "CP10", "CP25", "CP07",
      "CP18", "CP28", "CP04", "CP22", "CP13", "CP09", "CP26", "CP02", "CP17", "CP11", "CP20", "CP06", "CP15", "CP24"];

    const physPool = randomQuestions.filter(q =>
       q.type === "dpp"  && q.subject === "physics" && physTopics.includes(q.topic)
    );

    const physByTopic = {};
    physTopics.forEach(t => physByTopic[t] = physPool.filter(q => q.topic === t));

    const physSelection = [];
    for (let i = snum; physSelection.length < physTarget; i++) {
      const currentTopic = physTopics[i % physTopics.length];
      if (physByTopic[currentTopic] && physByTopic[currentTopic].length > 0) {
        physSelection.push(physByTopic[currentTopic].shift());
      }
      if (physTopics.every(t => physByTopic[t].length === 0)) break;
    }


    // --- 2. CHEMISTRY SECTION (25%) ---
    const chemTarget = Math.round(quesNum / 4);
    // Using your specific randomized order
    const chemTopics = [ "CC27", "CC05", "CC22", "CC09", "CC18", "CC02", "CC25", "CC11", "CC07", "CC28", "CC13",
      "CC04", "CC21", "CC16", "CC08", "CC26", "CC01", "CC23", "CC10", "CC15", "CC03", "CC12", "CC17", "CC06", "CC24"];

    const chemPool = randomQuestions.filter(q =>
        q.type === "dpp"  && q.subject === "chemistry" && chemTopics.includes(q.topic)
    );

    const chemByTopic = {};
    chemTopics.forEach(t => chemByTopic[t] = chemPool.filter(q => q.topic === t));

    const chemSelection = [];
    for (let i = snum; chemSelection.length < chemTarget; i++) {
      const currentTopic = chemTopics[i % chemTopics.length];
      if (chemByTopic[currentTopic] && chemByTopic[currentTopic].length > 0) {
        chemSelection.push(chemByTopic[currentTopic].shift());
      }
      if (chemTopics.every(t => chemByTopic[t].length === 0)) break;
    }


    // --- 3. BIOLOGY SECTION (50%) ---
    const bioTarget = Math.round(quesNum / 2);
    // Using your specific randomized order
    const bioTopics = ["CB14", "CB27", "CB05", "CB22", "CB09", "CB18", "CB02", "CB36", "CB25", "CB19", "CB07",
      "CB33", "CB28", "CB13", "CB04", "CB37", "CB21", "CB08", "CB29", "CB26", "CB01", "CB10",
      "CB34", "CB15", "CB03", "CB20", "CB30", "CB17", "CB06", "CB35", "CB24", "CB32"];

    const bioPool = randomQuestions.filter(q =>
        q.type === "dpp"  && q.subject === "biology" && bioTopics.includes(q.topic)
    );

    const bioByTopic = {};
    bioTopics.forEach(t => bioByTopic[t] = bioPool.filter(q => q.topic === t));

    const bioSelection = [];
    for (let i = snum; bioSelection.length < bioTarget; i++) {
      const currentTopic = bioTopics[i % bioTopics.length];
      if (bioByTopic[currentTopic] && bioByTopic[currentTopic].length > 0) {
        bioSelection.push(bioByTopic[currentTopic].shift());
      }
      if (bioTopics.every(t => bioByTopic[t].length === 0)) break;
    }

    // Combine results
    return [
      ...physSelection,
      ...chemSelection,
      ...bioSelection
    ];
  }
  else {   // Topic wise select questins
    return randomQuestions.filter(question =>
        (question.type === "dpp" )&&
      question.subject === subject &&
      question.topic === topic
      // question.quiz === quizNum
    ).slice(0, quesNum);
  }
};